import React from 'react';
import { Paper } from '@mui/material';

const NeonCard = ({ children, glow = '#00E5FF', sx, ...props }) => (
  <Paper
    elevation={0}
    sx={[
      {
        position: 'relative',
        p: 3,
        borderRadius: 1,
        overflow: 'hidden',
        height: '100%',
        // Halo behind border for all dashboard containers.
        boxShadow: `0 0 0 1px rgba(124, 185, 255, 0.18), 0 0 24px -12px ${glow}, 0 0 44px -28px ${glow}`,
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          padding: '1px',
          background: `linear-gradient(105deg, ${glow}, transparent 80%)`,
          WebkitMask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          WebkitMaskComposite: 'xor',
          pointerEvents: 'none',
        },
        '&:after': {
          content: '""',
          position: 'absolute',
          inset: '-1px',
          borderRadius: 'inherit',
          pointerEvents: 'none',
          boxShadow: `inset 0 0 22px -8px ${glow}`,
          opacity: 0.7,
        },
      },
      sx,
    ]}
    {...props}
  >
    {children}
  </Paper>
);

export default NeonCard;
